<template>
    <div class="productionReport">
        <van-nav-bar
            title=""
            left-text="应用"
            left-arrow
            @click-left="onClickLeft"
            @click-right="showFilterPop = true"
        >
            <template #title>
                <van-tabs
                    v-model="activeIndex"
                    animated
                    @click="toggletab"
                >
                    <template v-for="(item,index) in navData">
                        <van-tab
                            :key="index"
                            :title="item.name"
                        >
                        </van-tab>
                    </template>
                </van-tabs>
            </template>
            <template #right>
                <img class="shaixuan" src="../../../../assets/images/leadingCockpit/shaixuan.png">
            </template>
        </van-nav-bar>
        <filterConditions
            :show-filter-pop.sync="showFilterPop"
            @sureBack="sureBack"
        ></filterConditions>
        <section class="main-wrapper">
            <div class="box-wrapper">
                <keep-alive>
                    <component :is="currentView" :filter-data="filterData"></component>
                </keep-alive>
            </div>
        </section>
    </div>
</template>

<script>
// 当日产量
import sameDayYield from './currentDay.vue';
// 当年产量
import thatYearYield from './currentYear.vue';
import filterConditions from '../filterConditions/index';
export default {
    data() {
        return {
            showFilterPop: false,
            currentView: 'sameDayYield',
            activeIndex: 0,
            navData: [
                {
                    name: '当日产量',
                    value: 'sameDayYield',
                },

                {
                    name: '当年产量',
                    value: 'thatYearYield',
                },
            ],
            filterData: {},
        };
    },
    components: {
        sameDayYield,
        thatYearYield,
        filterConditions,
    },
    methods: {
        sureBack(params) {
            this.filterData = params;
        },
        toggletab(index) {
            this.currentView = this.navData[index].value;
        },
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
    },
};
</script>

<style lang="stylus">
.productionReport
    width 100%
    height 100%
    display flex
    flex-direction column
    .van-nav-bar
        display flex
        .van-nav-bar__title
            max-width 100%
            .van-tabs
                .van-tabs__nav
                            background rgba(0,0,0,0)
                    .van-tab
                        flex-basis auto !important
                        font-size 14rpx
                        margin 0 6rpx
                        line-height 44rpx
                        color rgba(240,240,240,0.5)
                        transition 0.2s
                        &.van-tab--active
                            font-size 16rpx
                            line-height 44rpx
                            color #FFFFFF
                        .van-tab__text
                            white-space nowrap
                    .van-ellipsis
                        text-overflow initial
                    .van-tabs__line
                        display none
                .van-tabs__wrap
                    &:after
                        display none
        .van-ellipsis
            white-space normal
        .van-nav-bar__right
            right 15rpx!important;
            width 0
            .shaixuan
                width 18rpx;
    .main-wrapper
        flex 1
        overflow hidden
        .box-wrapper
            height 100%
            overflow-y auto
</style>
